module.exports = __webpack_public_path__ + "img/leadercup.2c90ad5e.svg";